module.exports = __webpack_public_path__ + "img/ab-testing.ae3553f3.svg";